
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Bu,
                    <a href="${0}">Folksonomi Motoru projesi</a>tarafından getirildi. Katılmaktan veya geri bildirim vermekten
                    çekinmeyin.`,
'h5d824b4954e56ea5': html`<span class="everyday">günlük</span> <span class="foods">yiyeceklerinizi</span>tarayın`,
'h6bdd1b427aa985a4': html`Bu araç, içerik listesini düzeltmenize olanak tanır.
                içerik listesini ekleyebilir, kaldırabilir veya düzenleyebilirsiniz.
                <br>
                Bu karakter <span class="highlight">␣</span> bir boşluğu temsil eder.
                <br>
                Bu karakter <span class="highlight">↩︎</span> bir satır sonunu temsil eder. `,
'hb28f1f2ec1744ee9': html`Bu özellikler, kullanıcılar tarafından her türlü kullanım için oluşturulur ve dosyalanır. Kendi özelliklerinizi eklemekten çekinmeyin. Oluşturduğunuz özellikler ve değerler
<strong>gerçeklere dayalı olmalıdır</strong>. Topluluk tarafından halihazırda kullanılan mülklerin
<a href="${0}">listesine göz atabilir</a>veya mülklerin
<a href="${1}">belgelerini ve arama motorunda</a> inceleyebilirsiniz.`,
's000a5b76bd3a01c2': `Özellikler yükleniyor...`,
's000d98595e959c1e': `Google Play'de Mevcut`,
's013bdc8cf0d3583d': `Malzemeler için bize yardım edin`,
's01d2865e3e1d5501': `Yardımınız için teşekkür ederim!`,
's02ce7a2e7c1b020b': `Mahsulü doğrula`,
's03e9c8114521b998': `Malzemeleri düzenleyeceğim`,
's05ec315d9308091a': `Barkod köşeleri simgesi`,
's061eb5af92512c85': `Kaydedildi! Başka bir tane konusunda yardımcı olabilir misiniz?`,
's06847c221c4c0bc1': `[Kullanım durumunuzu açıklayın] için bir özellik oluşturmak istiyorum...`,
's06f6c6f99db6b552': `Orijinal`,
's081e2ad82db71e1d': `Gruplanmış Değerler`,
's09205907b5b56cda': `Hayır`,
's0b4235aae602a950': `özel dokümantasyon`,
's0bb2d48532acc455': `CSV'yi indirin`,
's0d5b7fee0311db68': `Özellik`,
's0fb218abc2e157ed': `Resmi geçersiz kıl`,
's100c4928cc74642a': `halk sağlığı araştırmalarının ilerlemesini desteklemek.`,
's10db5498186c083b': `Kırpmayı iptal et`,
's11a18a69b30b65ed': `İçerik listesindeki hataları düzeltmemize yardımcı olun`,
's1205d5f6fccf8e69': `Emlak Değeri`,
's15d64a0a6715285a': `Yeni anahtar`,
's166bd56d19670a72': `Yakınlaştır`,
's19059bf0c4f7c162': `Seçim alanı`,
's1a52515ec8ddade8': `Ürün barkodu`,
's1c5031113de500ce': `veritabanımızı açık tutarak &amp; herkesin kullanımına sunuyoruz,`,
's1dc4daf989c71284': `Beslenme bilgilerini düzeltmemize yardımcı olun`,
's1e00019dc454872d': `Lütfen property-name niteliğini kullanarak bir özellik adı sağlayın.`,
's1e49126af0935a5b': `Bu özelliği kullanan ürünlerin listesi`,
's21e73088de6f26f3': `App Store'da Mevcut`,
's255857544a9d5ec0': `Sıfırla`,
's25e94495991e95ba': `Yardımınız için teşekkürler! Başka bir soruma yardımcı olabilir misiniz?`,
's2ceb11be2290bb1b': `İptal`,
's2db7b654c0a9bde0': `Mülkü belgelendirin`,
's300b3a6ee4e1252d': str`Kötü Eşleşme ${0}%`,
's33f786bb6b4f0cf4': `Mahsul Sonucu`,
's33f85f24c0f5f008': `Kaydet`,
's34be4af4e8fec4ae': `Önce topluluğa sorun`,
's36d86adc823cbfa6': `Yeni bir özellik oluşturmadan önce bunu toplulukla görüşün:`,
's3781d25aa51a736c': `Folksonomi Motoru Dokümantasyonu`,
's383ae4449428b61e': `Kırpmayı sıfırla`,
's39bcf88721a1e8ee': `Seçimi sıfırla`,
's39e14e14300694c7': `Belgeler ve Yönergeler`,
's3b430cfa5c1fe7f4': str`${0}için belgeler`,
's3f4e4b52f230a892': `Resim tuvali`,
's417b90913e05bc17': `Ön izleme`,
's41f7dca46d3f1b4a': `Değer`,
's422bba9636ce2489': `Ortadaki resim`,
's42dd66b2441566fd': `Orta simgesi`,
's43df2e8395f6834e': str`Lütfen ${0} Bağış Toplama Kampanyamıza bağışta bulunun`,
's453188ea728f64da': `Besin ögesi ekle`,
's453ab0dbb9b5c777': `Sağa yeniden boyutlandır`,
's475b08749d0706ed': `Dünya çapında milyonlarca tüketiciyi ne yedikleri konusunda bilgilendirmemize yardımcı olun`,
's49730f3d5751a433': `Yükleniyor...`,
's4bbc7472834a9686': `Tarayıcınız barkod taramasını desteklemiyor.`,
's4d42cc7e00076a3b': `Ürün Sayısı`,
's4df2f533c0c1e7d0': `Görüntü kontrolleri`,
's4e94adf723979402': `Open Food Facts'ın bu ürünle ilgili yardımınıza ihtiyacı var.`,
's4f4886341969d552': `Seçimi taşı`,
's4f751fb9b3ed766c': `Yeni Bir Mülk Oluşturma`,
's547c12ae169d00bc': `F-Droid'de mevcut`,
's5560fb119e40923d': `Emlak adını girin...`,
's55d7249883a98ca1': `Açık Gıda Bilgileri wiki'sinde bu mülk hakkında`,
's565867d84c04aea2': `Filtre özellikleri...`,
's5666afe5cd0166de': `Lütfen onaylamadan önce hataları düzeltin veya metni değiştirin`,
's57472465a23b41db': `Değerler`,
's58e1eeea7a60ae51': `Ürünler yükleniyor...`,
's59df20feee978e5b': `Hata: Geçersiz değer.`,
's5c92c0051d44b6de': `Beslenme bilgilerini düzeltmemize yardımcı olun.`,
's5dd6f12783fca34f': `Malzeme listesini düzenle`,
's5e8250fb85d64c23': `Kapat`,
's5ed03bb1f3a15949': `Resim`,
's6306a31415aea913': `DESTEKLİYORUM`,
's6498dfe4855bb3a7': `birim`,
's64ef2a6c2dd1d3d1': `Düzenle`,
's66413c24dcf680e2': `Atla`,
's67ae6594857a4d57': `Katkılarınız için teşekkürler!`,
's6cee7cad81dfedd1': `Kırpılmış Görüntü`,
's6d7b6cdedaadfb6e': `Her bağış değerli! Dünyada gıda şeffaflığını daha da artırma yolundaki desteğiniz için teşekkür ederiz.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`İyi Eşleşme ${0}%`,
's71a5c9f4b68ef4d4': `Miktar`,
's74cb3d66f6a668e1': `Belgeleme`,
's787dd11bed0dc88a': `Sola yeniden boyutlandır`,
's7ce4fd9430e80cea': `değer`,
's801a05fa8e881f37': `Emlak oluşturma ve kuralları hakkında daha fazla bilgi edinin:`,
's8038273de2cf8b73': `Lütfen kırpmak için bir bölge seçin.`,
's839cc2908a5387f2': `Barkodları filtrele...`,
's86197dcf3e96af64': `Mevcut mülklere göz atın ve arayın`,
's8a63be30a129a59c': `Alt kısmı yeniden boyutlandır`,
's8a8bfd67f2dd2810': `Bu QR koduyla OFF uygulamasını indirin`,
's8af61807443f32a4': `Eylemler`,
's8b33c244759d7bd4': `Sağ üst kısmı yeniden boyutlandır`,
's8db84aa4bc949af2': `Yeni Özelliği Belgeleyin`,
's8f839a03997a16d7': `Ürünü Görüntüle`,
's901ae1e236ac45d3': `Silmeyi iptal et`,
's907f7a97c6b29425': `Veri modelinin değiştirilebileceğinin farkında olun. Kendi riskinizle kullanın.`,
's95d23d03f9147581': `Yakınlaştırmayı kaldır`,
's976dfd19ef58a1e1': `Bir barkodu tarayıp ayrıntılarını (sağlık, tercihler vb.) öğrenmek için tıklayın`,
's98ff35f2a00dc60d': `İçindekiler :`,
's9a7f60fce090ecaf': `Özellikler yüklenemedi. Lütfen daha sonra tekrar deneyin.`,
's9b87abd68fb9df45': `Bulunamadı mı? Yeni anahtar oluştur {value}`,
's9c0f52425fd2f07e': `Eşleşmeyebilir`,
's9fc41f789c63b40d': `Ürünler`,
'sa1fa766e0d5634d7': `Puan Yok`,
'sa548778b24054030': `Folksonomy Engine projesinden katkıda bulunulan tüm özellikleri keşfedin. Bu özellikler, Açık Gıda Bilgileri veritabanındaki ürünler hakkında ek meta veriler ve içgörüler sağlar.`,
'sa63907958bd0ec4b': `Sol üst kısmı yeniden boyutlandır`,
'sa95b4224f685a36a': `Modali kapat`,
'sab56a1d439576fd6': `Öneri simgesi`,
'sac47ea2901d04c15': `Sol alt kısmı yeniden boyutlandır`,
'sb125227d436c2925': `Mevcut emlak veritabanında emlak konseptinizi arayın:`,
'sb125568d43642e6f': `Ürünle ilgili soruları cevaplayın.`,
'sb1c538e038f9b214': str`Çok İyi Eşleşme ${0}%`,
'sb28639570ff3b852': `tüm özelliklerin listesi`,
'sb3bdd638a58d30f4': `bağlı vatandaşlardan oluşan bir topluluğu harekete geçirmek,`,
'sb3cbcc1bd0fff140': `Mülkünüzün mevcut olmadığını doğruladıktan ve topluluk tarafından yararlı olduğu kabul edildikten sonra, öncelikle onu wiki'de belgelemeniz gerekir.`,
'sb3d4f79d9d8b71e5': `Gönder`,
'sb560fa37a7bfb6c2': `Bu mülk için ürün bulunamadı.`,
'sb7f72e4c8a2d3357': `Filtre değerleri...`,
'sb8178320160f84ea': `Kırpmayı göster`,
'sbad7d2734149470b': `Geçerlilik`,
'sbb623d6b18d966a0': `Besin değerleri ambalaj üzerinde yer almaktadır:`,
'sbd6be5cde472f37c': `Tüm içgörüler cevaplandı! Yardımınız için teşekkürler!`,
'sbd9a0b2293b3cd3c': `Porsiyon ölçüsü`,
'sbe472dc3c2685985': `Karşılık Gelen Değer`,
'sc0520e1732a5c568': `Resmi genişlet`,
'sc0cc559e7ede852a': `Üst kısmı yeniden boyutlandır`,
'sc1c08d0cbcc3bd24': `Eşleşmiyor`,
'sc52696641af72b53': `Uygulamayı yükle!`,
'sc5575e3107f87874': `Resmi sola döndür`,
'sc57b630a7a70c61f': `Önerilen düzeltme`,
'sc681b137e8f604f7': `Silme işlemini onayla`,
'sc6daf8a31883f8b9': `Resmi taşı`,
'sc895972c88d38ca5': `Folksonomi özelliği`,
'sca0c3305aff570b8': str`belirtilen porsiyon başına "${0}"`,
'scace072bef961918': `Satırlar`,
'scb3b0671d7b7f640': `Yeni değer`,
'scb489a1a173ac3f0': `Evet`,
'scbab4bd737ba7934': str`grup fotoğrafı bağışı ${0}`,
'scd21019c3cd618f3': `Slack Tartışmasına Katılın`,
'scdb6cad0b92721bf': `Hiçbir özellik bulunamadı.`,
'scf23a05631f93732': `Silmeyi Onayla`,
'scfed2f270ef6a3aa': `Alan seçin`,
'sd1022bc1ef9204f7': `Yakınlaştırılabilir görüntü`,
'sd1077c055cf9ba6b': `Ürünün içerik listesini doğrulamamıza yardımcı olun.`,
'sd698d21ddecba56b': `Merhaba! Aşağıdaki kısımları cevaplayarak ürün bilgilerini iyileştirmemize yardımcı olabilirsiniz:`,
'sd82bc2decefa621b': `gıda endüstrisinden bağımsız kalmak,`,
'sdb97e5976482606e': `Bir özelliğin zaten mevcut olup olmadığını kontrol edin`,
'sdbf806fefc584115': `Bir tane bulmalısın`,
'sdc673e73b5c13aea': `Sil`,
'sdc792b75f1edcaba': `Malzemelerin yazımını düzeltmemize yardımcı olun.`,
'sdca5deead576ceee': `Sağ alt kısmı yeniden boyutlandır`,
'sdcc2555c5dde524f': `Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.`,
'se206feec7ec57b28': `100g başına`,
'se419a9ab36987490': `Geçersiz kıl`,
'se5127cf0f92e7e48': `İpucu: Ayrıca şunu da bulabilirsiniz:`,
'se773f50d2a16d481': `Resmi sağa döndür`,
'sebb2c6c830a44574': `teknik altyapı (web sitesi/mobil uygulama) &amp; küçük ve kalıcı bir ekip`,
'sec6377f3c4e9b28c': `Daha iyi bir ürün önereceğim`,
'seea3800e27baa686': `Bireysel Ürünler`,
'sefaba4adc4ec9219': `Folksonomi Özellikleri`,
'seffa8ca49175b5f0': `Kişiselleştirilmiş özellikler`,
'sf44a6b3b232c28ea': str`Mevcut değeri ${0}ile değiştir`,
'sf4cd86a2f5ef2588': `Ürün Barkodu`,
'sf57a61152168cc81': `İçerik tespitini düzeltmemize yardımcı olun`,
'sf88b90b8ba23871c': `Bilinmeyen Eşleşme`,
'sf9aee319a006c9b4': `Ekle`,
'sfacbbe968fa7d773': `Emlak adı:`,
'sfc40ea3d5d5aa6f8': `Bağışlarınız, kâr amacı gütmeyen derneğimizin günlük faaliyetlerini finanse ediyor:`,
'sfe87465d50530725': `Karşılık gelen değer`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  